import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import dayjs from 'dayjs';
import { Component } from 'preact';
import { AuctionAPI } from '../../api/AuctionClient';
import { BidAmount } from './modal/BidAmount';
import { BidStatus } from './modal/BidStatus';
import { Carousel } from './modal/Carousel';
export class InfomationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }
    render() {
        const auction = this.props.auction;
        return (_jsxs("div", Object.assign({ class: `AuctionPanel__Modal modal is-clipped ${this.state.open === true ? 'is-active' : ''}` }, { children: [_jsx("div", { class: "modal-background", onClick: _ => { this.handleClose(); } }, void 0),
                _jsxs("section", Object.assign({ class: "modal-card" }, { children: [_jsxs("header", Object.assign({ class: "modal-card-head header" }, { children: [_jsx("p", Object.assign({ class: "modal-card-title" }, { children: auction.name }), void 0),
                                _jsx("i", Object.assign({ class: "icon times", onClick: _ => { this.handleClose(); } }, { children: "\u00D7" }), void 0)] }), void 0),
                        _jsxs("section", Object.assign({ class: "modal-card-body body" }, { children: [_jsx(Carousel, { s3Objects: auction.imagePivots.map(m => m.s3Object) }, void 0),
                                _jsxs("div", Object.assign({ class: "infomation" }, { children: [_jsx(BidStatus, { auction: auction }, void 0),
                                        _jsx(BidAmount, { auction: auction }, void 0),
                                        _jsx("article", Object.assign({ class: "message is-small is-dark" }, { children: _jsx("div", Object.assign({ class: "message-body" }, { children: auction.description }), void 0) }), void 0),
                                        _jsx("div", Object.assign({ class: "tags is-justify-content-flex-end" }, { children: _jsx("a", Object.assign({ href: auction.helpLinks, class: "tag is-dark", target: "_blank" }, { children: auction.helpLinks }), void 0) }), void 0)] }), void 0)] }), void 0),
                        _jsxs("footer", Object.assign({ class: "modal-card-foot is-justify-content-space-between" }, { children: [_jsx("div", Object.assign({ class: "is-size-6" }, { children: _jsx("span", { children: "FirstPayment\u00AEAuction" }, void 0) }), void 0),
                                _jsxs("div", { children: [_jsx("button", Object.assign({ type: "button", class: "button is-small is-link is-outlined", onClick: _ => { this.handleOpenQAModal(); } }, { children: "\u51FA\u54C1\u8005\u3078\u8CEA\u554F" }), void 0),
                                        _jsx("button", Object.assign({ type: "button", class: "button is-small is-link", disabled: this.handleYetStart(), onClick: _ => { this.handleBidButtonClick(); } }, { children: "\u5165\u672D" }), void 0)] }, void 0)] }), void 0)] }), void 0)] }), void 0));
    }
    handleOpen() {
        document.documentElement.style.overflow = "hidden";
        this.setState({
            open: true
        });
    }
    handleClose() {
        document.documentElement.removeAttribute("style");
        this.setState({
            open: false
        });
    }
    handleOpenQAModal() {
        this.props.questionModalHook();
    }
    handleBidButtonClick() {
        const frontUrl = AuctionAPI.resolveFrontEndUrl(this.props.auction.uuid, this.props.env);
        location.href = frontUrl;
    }
    handleYetStart() {
        if (this.props.env.length === 0) {
            return true;
        }
        return dayjs(this.props.auction.startDatetime).isAfter(dayjs());
    }
}
